function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React, { useState, useRef, useEffect } from "react";
import { useResizeObserver } from "@diana-ui/hooks";
import { register } from "@diana-ui/registry";
import * as TextInputStyles from "./TextInput.style";

var TextInput = _ref => {
  var {
      className,
      hasError,
      focusLabel,
      label = "",
      onChange: _onChange,
      disabled,
      prefixIcon,
      suffixIcon,
      ref
    } = _ref,
    props = _objectWithoutProperties(_ref, [
      "className",
      "hasError",
      "focusLabel",
      "label",
      "onChange",
      "disabled",
      "prefixIcon",
      "suffixIcon",
      "ref"
    ]);

  var [isFocused, setIsFocused] = useState(false);
  var [hasContent, setHasContent] = useState(false);
  var [legendWidth, setLegendWidth] = useState(0);
  var hiddenLabel = useRef(null);
  useEffect(() => {
    var _props$value, _props$value$toString;

    var length =
      ((_props$value = props.value) === null || _props$value === void 0
        ? void 0
        : (_props$value$toString = _props$value.toString()) === null ||
          _props$value$toString === void 0
        ? void 0
        : _props$value$toString.length) || 0;
    setHasContent(length > 0);
  }, [props.value]); // observer that keeps track of hidden label width and sets legendWidth accordingly

  var labelResizeObserver = useResizeObserver(
    entries => {
      entries.forEach(entry => {
        var { width } = entry.contentRect;

        if (width !== legendWidth) {
          setLegendWidth(width);
        }
      });
    },
    [legendWidth]
  );
  useEffect(() => {
    var hiddenLabelEl = hiddenLabel.current;

    if (hiddenLabelEl) {
      labelResizeObserver.observe(hiddenLabelEl);
    }

    return () => {
      if (hiddenLabelEl) {
        labelResizeObserver.unobserve(hiddenLabelEl);
      }
    };
  }, [hiddenLabel, labelResizeObserver]);
  return /*#__PURE__*/ React.createElement(
    TextInputStyles.Fieldset,
    {
      className: [className, isFocused && "focus", hasContent && "active"]
        .filter(Boolean)
        .join(" "),
      hasError: hasError,
      disabled: disabled
    },
    /*#__PURE__*/ React.createElement(
      TextInputStyles.Legend,
      {
        focusLabel: focusLabel,
        isFocused: isFocused,
        label: label,
        hasContent: hasContent,
        legendWidth: legendWidth
      },
      label
    ),
    /*#__PURE__*/ React.createElement(
      TextInputStyles.HiddenLabel,
      {
        ref: hiddenLabel
      },
      label
    ),
    /*#__PURE__*/ React.createElement(
      TextInputStyles.LabelContainer,
      null,
      /*#__PURE__*/ React.createElement(
        TextInputStyles.TextLabel,
        {
          focusLabel: focusLabel,
          isFocused: isFocused,
          hasContent: hasContent,
          labelWithPrefix: !!prefixIcon
        },
        label
      )
    ),
    /*#__PURE__*/ React.createElement(
      TextInputStyles.InputContainer,
      null,
      typeof prefixIcon === "string"
        ? /*#__PURE__*/ React.createElement(TextInputStyles.PrefixIcon, {
            name: prefixIcon,
            size: 16
          })
        : prefixIcon &&
            /*#__PURE__*/ React.createElement(TextInputStyles.PrefixWrapper, null, prefixIcon),
      /*#__PURE__*/ React.createElement(
        TextInputStyles.Input,
        _extends({}, props, {
          disabled: disabled,
          onChange: e => {
            if (_onChange) {
              _onChange(e);
            }

            setHasContent(e.target.value.length > 0);
          },
          onBlur: e => {
            var _props$onBlur;

            setIsFocused(false);
            return (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0
              ? void 0
              : _props$onBlur.call(props, e);
          },
          onFocus: e => {
            var _props$onFocus;

            setIsFocused(true);
            return (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0
              ? void 0
              : _props$onFocus.call(props, e);
          }
        })
      ),
      typeof suffixIcon === "string"
        ? /*#__PURE__*/ React.createElement(TextInputStyles.SuffixIcon, {
            name: suffixIcon,
            size: 16
          })
        : suffixIcon &&
            /*#__PURE__*/ React.createElement(TextInputStyles.SuffixWrapper, null, suffixIcon)
    )
  );
};

TextInput.displayName = "TextInput";
register(TextInput);
export { TextInputStyles };
export default TextInput;
